<template>
  <div>
    <h1 class="text-headline-small text-md-display-medium text-lg-display-large text-xl-display-large text-truncate">
      Tableau de bord de gestion
    </h1>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped></style>
